import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const BudgeUnpaidIcon = ({ size, deg, e2eId, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, deg: deg, "data-e2e-id": e2eId },
    React.createElement("rect", { width: "14", height: "14", x: "3", y: "3", fill: "none", fillRule: "evenodd", stroke: "#CCA758", rx: "7" })));
export const BudgeUnpaid = iconGenerator(BudgeUnpaidIcon);
//# sourceMappingURL=BudgeUnpaid.js.map